import api from './client';

class AuditAPI {
  static async events(payload = {}) { return (await api.post('/audit/events', payload)).data.data; }
  static async eventsSigned(payload = {}) { return (await api.post('/audit/events/signed', payload)).data.data; }

  static async meLoginHistory(params = {}) { return (await api.get('/audit/me/login-history', { params })).data.data; }
  static async meSecurityChanges(params = {}) { return (await api.get('/audit/me/security-changes', { params })).data.data; }
  static async meActions(params = {}) { return (await api.get('/audit/me/actions', { params })).data.data; }

  static async orgActivity(orgId, params = {}) { return (await api.get(`/audit/orgs/${orgId}/activity`, { params })).data.data; }
  static async orgAccessLogs(orgId, params = {}) { return (await api.get(`/audit/orgs/${orgId}/access-logs`, { params })).data.data; }
  static async orgExport(orgId, payload = {}) { return (await api.post(`/audit/orgs/${orgId}/export`, payload)).data.data; }

  static async adminSearch(params = {}) { return (await api.get('/admin/audit/search', { params })).data.data; }
  static async adminEntry(id, params = {}) { return (await api.get(`/admin/audit/entries/${id}`, { params })).data.data; }
  static async adminSession(sessionId, params = {}) { return (await api.get(`/admin/audit/sessions/${sessionId}`, { params })).data.data; }
  static async adminSuspicious(params = {}) { return (await api.get('/admin/audit/suspicious', { params })).data.data; }

  static async verifyIntegrity(payload = {}) { return (await api.post('/sys/audit/verify-integrity', payload)).data.data; }
  static async retentionPolicies() { return (await api.get('/sys/audit/retention-policies')).data.data; }
  static async archive(payload = {}) { return (await api.post('/sys/audit/archive', payload)).data.data; }
  static async purge(payload = {}) { return (await api.post('/sys/audit/purge', payload)).data.data; }

  static async aiDecisions(params = {}) { return (await api.get('/audit/ai/decisions', { params })).data.data; }
  static async aiPrompts(requestId, params = {}) { return (await api.get(`/audit/ai/prompts/${requestId}`, { params })).data.data; }
  static async aiEvaluations(params = {}) { return (await api.get('/audit/ai/evaluations', { params })).data.data; }

  static async diff(eventId) { return (await api.get(`/audit/diff/${eventId}`)).data.data; }
  static async rollbackRequest(payload = {}) { return (await api.post('/audit/rollback-request', payload)).data.data; }

  static async health() { return (await api.get('/sys/audit/health')).data.data; }
  static async stats() { return (await api.get('/sys/audit/stats')).data.data; }
}

export { AuditAPI as audit };
